module.exports = __webpack_public_path__ + "img/2014-02_bloomberg.54a26ad3.png";